export default __webpack_public_path__ + "8228dbd5991fa18d51260a330d7c4b82.svg";